import React from 'react';

import { HeadlineH8, SubtitleST4 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';

interface PartNumbersProps {
  items: string[];
  className?: string;
}

const PartNumbers = ({ items, className }: PartNumbersProps) => {
  const { t } = useLocalization();

  return (
    !!items.length && (
      <section className={className} data-testid="part-numbers">
        <HeadlineH8 as="h2">{t('h24_part_numbers')}:</HeadlineH8>
        <SubtitleST4>{items.join(', ')}</SubtitleST4>
      </section>
    )
  );
};

export default PartNumbers;
